import styled from 'styled-components';

export const InfoSectionContent = styled.div`
  --color-page-secondary: #008ab5;
  --color-range-ball: #263f6d;
  --color-page-primary: #004297;

  .info-section {
    padding: 1rem 1.5rem;
    margin: 6rem auto;
    position: relative;
    max-width: 1440px;
    overflow: hidden;

    h2 {
      margin-bottom: 32px;
      color: #c40023;
      font-family: Arial, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 30px;
      line-height: 34px;
      text-align: center;
    }

    &.info-allya {
      width: 100%;
      height: 100%;
    }

    .main-button {
      margin: 25px auto 0 auto !important;
    }

    .column-info {
      margin: auto;
      background: white;
      padding: 40px;
      box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
      max-width: 640px;

      .description-box {
        text-align: center;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 150%;
        color: #666765;

        button {
          background: #ff8723;
          width: 100%;
          max-width: 212px;
        }
      }
    }

    .register-section {
      .content {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  @media (max-width: 768px) {
    .info-section {
      margin: 2rem auto 0;

      .main-button {
        margin: 10px auto !important;
      }

      h2 {
        margin-bottom: 33px;
      }

      .column-info {
        position: relative;
        width: 100%;
      }

      .register-section {
        padding: 0;

        .content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
`;

export const InfoBox = styled.div`
  text-align: center;
  margin-right: 20px;
  max-width: 260px;

  img {
    width: 121px;
    height: 110px;
    margin: 30px;
  }

  p {
    font-family: 'Arial', sans-serif;
    font-size: 1.125rem;
    font-weight: 700;
    color: #c40023;
  }

  span {
    color: #666765;
  }

  &:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 768px) {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    max-width: none;

    img {
      width: 80px;
      padding: 16px;
      margin: 0 15px;
    }

    div {
      text-align: left;

      p {
        margin-bottom: 11px;
      }

      span {
        padding: 0;
      }
    }
  }

  @media (max-width: 425px) {
    margin-right: 0;

    img {
      margin-left: 0;
    }
  }
`;

interface BgImageProps {
  image: string;
  position?: string;
  top?: number | string;
  left?: number | string;
  right?: number | string;
  bottom?: number | string;
  width?: number | string;
  height?: number | string;
  showOnMobile?: boolean;
}

const getValue = (value: string | number | undefined, defaultValue = 'unset') => {
  if (value) {
    if (typeof value !== 'string') {
      return `${value}px`;
    }

    return value;
  }

  return defaultValue;
};

export const BgImage = styled.div<BgImageProps>`
  background-image: url('${({ image }) => image}');
  position: absolute;
  width: ${({ width }) => getValue(width, '100%')};
  height: ${({ height }) => getValue(height, '100%')};
  background-position: ${({ position }) => position || 'unset'};
  background-repeat: no-repeat;
  top: ${({ top }) => getValue(top)};
  left: ${({ left }) => getValue(left)};
  right: ${({ right }) => getValue(right)};
  bottom: ${({ bottom }) => getValue(bottom)};
  background-size: contain;

  @media (max-width: 768px) {
    display: ${({ showOnMobile }) => (showOnMobile ? 'block' : 'none')};
  }
`;
